import { render, staticRenderFns } from "./SubjectStatusCount.vue?vue&type=template&id=6708a8dd&scoped=true"
import script from "@/components/curriculum/SubjectStatusCount.ts?vue&type=script&lang=ts&external"
export * from "@/components/curriculum/SubjectStatusCount.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/curriculum/subject-status-count.scss?vue&type=style&index=0&id=6708a8dd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6708a8dd",
  null
  
)

export default component.exports